import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./motion-primitives";

const FAQS = [
  {
    q: "What can Holideviser help me plan?",
    a: "We help shape personalized holidays, including accommodation, experiences and travel arrangements through destination partners. Your proposal will explain exactly what is included and what is quoted separately.",
  },
  {
    q: "Can I enquire about a destination that isn't on the website?",
    a: "Yes. Our published guides cover places we know firsthand. Share the destination you have in mind and we'll confirm whether we can support your trip.",
  },
  {
    q: "Do you plan trips for families and groups?",
    a: "Yes. Tell us how many people are travelling, your room requirements and any different preferences within the group so these can be considered in the proposal.",
  },
  {
    q: "Has every hotel and experience been personally visited?",
    a: "No. Personally experienced recommendations are identified in our destination edits. A tailored proposal may also include partner-supplied services, which should not be assumed to have been personally visited.",
  },
  {
    q: "What happens after I send my enquiry?",
    a: "We review your brief and follow up to clarify the details. We then work toward a proposal for you to review and refine. Submitting the form does not confirm a booking.",
  },
  {
    q: "Will my proposal explain the costs?",
    a: "Your proposal will set out the quoted services, inclusions, exclusions and applicable charges. Review the final price, payment schedule and cancellation conditions before proceeding.",
  },
];

export const FaqSection = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10 lg:px-16 lg:py-20"
    >
      <SectionHeading
        overline="FAQ"
        title="A few things you might be wondering."
        testId="faq-heading"
      />
      <Reveal>
        <Accordion type="single" collapsible className="mt-12 max-w-3xl lg:mt-14" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-charcoal" data-testid={`faq-item-${i}`}>
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 font-serif text-xl font-light text-cream hover:no-underline [&>svg]:text-teal"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="max-w-2xl font-sans text-base leading-relaxed text-sand"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
};
